import script from "/app/components/money_input.vue?type=script";
import { render } from "/app/components/money_input.vue?type=template";
script.render = render;
export default script;
